import React from 'react'
import PropTypes from 'prop-types'

const getTrueCount = (array) => {
  let count = 0
  for (let i = 0; i < array.length; i++) {
    if (array[i].isValid) {
      count++
    }
  }
  return count
}

const sortByValid = (a, b) => (a.isValid === b.isValid ? 0 : a.isValid ? -1 : 1)
const RuleProgressBar = ({ rules }) => {
  return (
    <div className="col-12">
      <div
        className="row"
        role="progressbar"
        aria-valuenow={getTrueCount(rules)}
        aria-valuemin="0"
        aria-valuemax="4"
        aria-valuetext={`Força da senha`}
        aria-hidden="true"
      >
        {rules.sort(sortByValid).map((rule, i) => {
          return <RuleProgressBarUnit key={i} {...rule} />
        })}
      </div>
    </div>
  )
}

const RuleProgressBarUnit = ({ isValid }) => (
  <div className={`col pt-half radius mr-1 mb-1 ${isValid ? 'bg-success' : 'bg-ui-3'}`} />
)

RuleProgressBarUnit.propTypes = {
  isValid: PropTypes.bool.isRequired
}

export { RuleProgressBar }
export default RuleProgressBar
